import { call, put, select } from 'redux-saga/effects';

import dynaForms from '@elab/core/utils/dynaForms';
import dynaFormsApi from '@elab/core/utils/dynaForms/api';
import globalActions from '@elab/core/store/global/actions';
import globalTypes from '@elab/core/store/global/types';
import { createWatcher } from '@elab/core/store/core/saga';
import userSelectors from '@elab/core/store/user/selectors';
import orderSelectors from '@elab/core/store/order/selectors';
import orderActions from '@elab/core/store/order/actions';
import uiActions from '@elab/core/store/ui/actions';
import orderApi from '@elab/core/store/order/api';

import actions from './actions';

export function* doSubmit(dto) {
    const userId = yield select(userSelectors.getUserId);
    const orderCode = yield select(orderSelectors.getOrderCode);
    const entryNumber = yield select(orderSelectors.getEGiftEntryNumber);

    yield put(globalActions.resetFormsMessages());
    yield put(actions.resetFormData());
    yield put(uiActions.closeDialogByName('egift-card-resend-modal'));

    const isEGiftCardResetAttempts = yield call(orderApi.getEGiftCardResetAttempts, userId);

    yield put(orderActions.setEGiftCardResendAttempts(isEGiftCardResetAttempts));

    yield call(orderApi.submitEGiftCardResetEmail, userId, orderCode, entryNumber, dto);
}

export default storeName => formId => [
    ...dynaForms.createSagaFor(
        storeName,
        dynaFormsApi.getFormMetadata(formId || storeName),
        doSubmit,
        null,
        true,
    ),
    createWatcher(globalTypes.RESET_FORMS_MESSAGES, actions.resetGlobalMessage()),
];
